import * as stylex from '@stylexjs/stylex';
import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router';
import { MdVerifiedUser, MdFormatQuote, MdPersonAdd } from 'react-icons/md';
import { AppButton, useOpenApp } from '~components/AppCta';
import { UserAvatar } from '~components/UserAvatar';
import { shared } from '~styles';
import { styles } from './styles';
import { PUBLIC_USER } from './query';
import { Facts } from './components/Facts';
import { Languages } from './components/Languages';
import { Personality } from './components/Personality';
import { Interests } from './components/Interests';
import { TopArtists } from './components/TopArtists';
import { Stub } from './components/Stub';
export function Profile() {
  const {
    id = ''
  } = useParams();
  useOpenApp(`profile/${id}`);
  const {
    data,
    loading,
    error
  } = useQuery(PUBLIC_USER, {
    variables: {
      id
    }
  });
  if (loading) {
    return <main {...stylex.props(styles.container)}>
        <p {...stylex.props(shared.muted)}>Loading…</p>
      </main>;
  }
  const user = data?.publicUser;
  if (error || !user) return <Stub id={id} />;
  const name = user.fullName ?? user.username;
  return <main {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.identity)}>
        <UserAvatar name={name} avatarUrl={user.avatarUrl} size={176} radius={20} />
        <div {...stylex.props(styles.nameRow)}>
          {user.isVerified && <MdVerifiedUser size={24} {...stylex.props(styles.verified)} />}
          <h1 {...stylex.props(styles.name)}>{name}</h1>
        </div>
        <span {...stylex.props(styles.username)}>@{user.username}</span>
        <div {...stylex.props(styles.cta)}>
          <AppButton path={`profile/${user.id}`} label="Befriend" icon={<MdPersonAdd size={20} />} />
        </div>
      </div>

      <div {...stylex.props(styles.content)}>
        {user.bio && <div {...stylex.props(styles.bio)}>
            <MdFormatQuote size={22} {...stylex.props(styles.bioIcon)} />
            <p {...stylex.props(styles.bioText)}>{user.bio}</p>
          </div>}
        <Facts user={user} />
        <Languages languages={user.languages} />
        <Personality personality={user.personality} />
        <Interests interests={user.interests} />
        <TopArtists artists={user.spotifyArtists} />
      </div>
    </main>;
}